import React from 'react';

const Orange = () => {
  return <div>Orange</div>;
};

export default Orange;
